import { useCallback, useEffect, useState } from 'react';
import useLocalStorage from './useLocalStorage';
import { ModeUI } from '@/constants/enum';

const useColorMode = () => {
  const [colorMode, setColorMode] = useLocalStorage('color-theme', ModeUI.LIGHT);

  const getMode = useCallback(() => {
    let mode = colorMode
    if(mode === ModeUI.AUTO) {
      mode = window.matchMedia && window.matchMedia("(prefers-color-scheme:dark)").matches ? ModeUI.DARK : ModeUI.LIGHT
    }
    return mode
  }, [colorMode])

  useEffect(() => {
    const className = ModeUI.DARK
    const bodyClass = window.document.body.classList;

    window.dispatchEvent(new Event('local-storage-updated'))

    getMode() === ModeUI.DARK
      ? bodyClass.add(className)
      : bodyClass.remove(className);
  }, [colorMode]);

  const mode = getMode()

  return {colorMode, setColorMode, mode};
};

export default useColorMode;
